import { render, staticRenderFns } from "./usersc.vue?vue&type=template&id=1d47f3ca&scoped=true"
import script from "./usersc.vue?vue&type=script&lang=js"
export * from "./usersc.vue?vue&type=script&lang=js"
import style0 from "./usersc.vue?vue&type=style&index=0&id=1d47f3ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47f3ca",
  null
  
)

export default component.exports